module.exports = __webpack_public_path__ + "static/media/30OIOS3.bbc72e46.jpg";